import { Dialog, DialogActions, DialogContent, Button } from "@mui/material";
import ReportGarmentPdf from "./ReportGarmentPdf";

const DialogReportGarment = ({
  openReport,
  handleClose,
  productosAgrupados,
}) => {
  return (
    <Dialog fullWidth maxWidth="lg" open={openReport} onClose={handleClose}>
      <DialogContent>
        <ReportGarmentPdf productosAgrupados={productosAgrupados} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color={"secondary"} variant="contained">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogReportGarment;
